module.exports = __webpack_public_path__ + "static/cookie-x-c33e04b392c0e91ab7fd1a7cf3ce3c63.png";